import * as form from '../form';

export const substanceDrugSupplementalPublicSafety = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        DateRange: form.daterange(xitem.DateRange),
        NumberOfTimesUsed: form.text(xitem.NumberOfTimesUsed),
        DrugUsed: form.radio(xitem.DrugUsed),
        Comment: form.text(xitem.Comment)
      },
    };
  });
  return {
    EmployedIllegalControlledSubstanceUseAnswer: form.branch(data.EmployedIllegalControlledSubstanceUseAnswer),
    EmployedIllegalControlledSubstanceUseComment: form.textarea(data.EmployedIllegalControlledSubstanceUseComment),
    EmployedIllegalControlledSubstanceUseSummaryComment: form.textarea(data.EmployedIllegalControlledSubstanceUseSummaryComment),
    List: form.collection(items, (data.List || {}).branch),
  };
};
